"use strict";

window.addEventListener('load', () => {});
customElements.define('ec-cpm-modal', class extends HTMLElement {
  constructor() {
    super();
    this.state = {
      data: {},
      listeners: [],
      history: []
    };
    this.historyLimit = 100;
    this._isOpen = false;
    this._isScrollLocked = false;
    this._triggerElement = null;
    this._boundKeydownHandler = this._handleKeydown.bind(this);
    this._boundFocusHandler = this._handleFocusTrap.bind(this);
    this._focusableElements = [];
    this.cpmForm = document.querySelector('.ec-cpm__form');
  }
  connectedCallback() {
    this.state.data.sectionId = this.getAttribute('data-section-id');
    this.setAttribute('role', 'dialog');
    this.setAttribute('aria-modal', 'true');
    this.style.display = 'none';
    this._closeButton = this.querySelector('[data-modal-close]');
    if (this._closeButton) {
      this._closeButton.addEventListener('click', () => this.close());
    }
    if (this.hasAttribute('data-open')) {
      this.open();
    } else {
      this.setAttribute('aria-hidden', 'true');
    }
  }
  disconnectedCallback() {
    this.clearHistory();
    document.removeEventListener('keydown', this._boundKeydownHandler);
    this.removeEventListener('focusin', this._boundFocusHandler);
    if (this._triggerElement && typeof this._triggerElement.focus === 'function') {}
    document.body.classList.remove('no-scroll');
  }
  setState(keyOrObject, value) {
    if (typeof keyOrObject === 'object') {
      Object.entries(keyOrObject).forEach(([key, val]) => {
        this.state.data[key] = val;
        this.updateHistory(key, val);
        this.state.listeners.forEach(cb => cb(key, val));
      });
    } else {
      this.state.data[keyOrObject] = value;
      this.updateHistory(keyOrObject, value);
      this.state.listeners.forEach(cb => cb(keyOrObject, value));
    }
    const event = new CustomEvent(`${this.state.data.sectionId}-update`, {
      detail: {
        state: this.state.data
      }
    });
    document.dispatchEvent(event);
    if (window.gtm != null && typeof window.gtm.trackAvailability == "function") {
      if (this.state.data["variant"] != null) {
        window.gtm.trackAvailability(this.state.data.variant.custom);
      }
    }
  }
  updateHistory(key, value) {
    const existingIndex = this.state.history.findIndex(item => item.key === key);
    if (existingIndex >= 0) {
      this.state.history[existingIndex].value = value;
    } else {
      this.state.history.push({
        key,
        value
      });
    }
    if (this.state.history.length > this.historyLimit) {
      this.state.history.shift();
    }
  }
  clearHistory() {
    this.state.history = [];
  }
  setHistoryLimit(limit) {
    if (typeof limit === 'number' && limit >= 0) {
      this.historyLimit = limit;
      while (this.state.history.length > this.historyLimit) {
        this.state.history.shift();
      }
    } else {}
  }
  getState(key) {
    if (key === undefined) {
      return {
        ...this.state.data
      };
    }
    return this.state.data[key];
  }
  subscribe(cb, replayHistory = true) {
    this.state.listeners.push(cb);
    if (replayHistory && this.state.history.length > 0) {
      setTimeout(() => {
        this.state.history.forEach(change => {
          cb(change.key, change.value);
        });
      }, 0);
    }
    return () => {
      const index = this.state.listeners.indexOf(cb);
      if (index !== -1) {
        this.state.listeners.splice(index, 1);
      }
    };
  }
  _getFocusableElements() {
    const focusableSelector = ['a[href]', 'button:not([disabled])', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])', 'details > summary:first-of-type', '[contenteditable="true"]'].join(',');
    this._focusableElements = Array.from(this.querySelectorAll(focusableSelector)).filter(el => {
      const style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
    });
  }
  _handleFocusTrap(event) {
    if (this._isOpen && !this.contains(event.target)) {
      const firstFocusable = this._focusableElements[0];
      if (firstFocusable) {
        firstFocusable.focus();
      } else {
        if (this.hasAttribute('tabindex')) {
          this.focus();
        }
      }
    }
  }
  _handleKeydown(event) {
    if (!this._isOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }
    if (event.key === 'Tab') {
      this._getFocusableElements();
      if (!this._focusableElements.length) {
        event.preventDefault();
        return;
      }
      const firstElement = this._focusableElements[0];
      const lastElement = this._focusableElements[this._focusableElements.length - 1];
      const activeElement = this.contains(document.activeElement) ? document.activeElement : null;
      if (event.shiftKey) {
        if (activeElement === firstElement || !activeElement) {
          event.preventDefault();
          lastElement.focus();
        }
      } else {
        if (activeElement === lastElement || !activeElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }
  }
  x;
  lockScroll() {
    if (this._isScrollLocked) return;
    this._isScrollLocked = true;
    this.style.overflowY = 'hidden';
  }
  isTouchScreen() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isMobileUA = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua.toLowerCase());
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isDesktop = /windows nt|macintosh|linux x86_64/i.test(ua.toLowerCase());
    return isMobileUA || hasTouch && !isDesktop;
  }
  unlockScroll() {
    if (!this._isScrollLocked) return;
    this._isScrollLocked = false;
    this.style.overflowY = null;
  }
  open(selectedOption) {
    if (this._isOpen) return;
    window.neptune.clarity('new_fabric');
    const details = this.querySelector(`.ec-cpm .ec-cpm__body .ec-cpm__form li[data-option="${selectedOption}"] ec-cpm-details`);
    if (details && typeof details.open === 'function') {
      details.open();
      window.requestAnimationFrame(() => {
        if (!this.isTouchScreen()) {
          this.scrollTo({
            top: details.offsetTop - this.offsetTop
          });
        }
      });
    }
    this._triggerElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    this._isOpen = true;
    this.style.display = 'block';
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    this._getFocusableElements();
    const elementToFocus = this._focusableElements.find(el => el.hasAttribute('autofocus')) || this._focusableElements[0] || this;
    if (elementToFocus && typeof elementToFocus.focus === 'function') {
      requestAnimationFrame(() => {
        elementToFocus.focus();
      });
    }
    document.addEventListener('keydown', this._boundKeydownHandler);
    this.animate([{
      opacity: 0
    }, {
      opacity: 1
    }], {
      duration: 250,
      easing: 'ease-out',
      fill: 'forwards'
    });
  }
  close(element) {
    if (!this._isOpen) return;
    document.removeEventListener('keydown', this._boundKeydownHandler);
    this.animate([{
      opacity: 1
    }, {
      opacity: 0
    }], {
      duration: 200,
      easing: 'ease-in',
      fill: 'forwards'
    }).finished.then(() => {
      this.style.display = 'none';
      this._isOpen = false;
      document.body.classList.remove('no-scroll');
      this.unlockScroll();
      this.clearHistory();
      this.cpmForm.classList.remove("inactive");
      this.querySelectorAll('ec-cpm-details details[open]').forEach(details => {
        const detailsComponentEl = details.closest('ec-cpm-details');
        if (typeof detailsComponentEl.close === 'function') {
          detailsComponentEl.close();
        } else {
          details.removeAttribute('open');
        }
      });
      if (this._triggerElement && typeof this._triggerElement.focus === 'function') {
        this._triggerElement.focus();
      }
      this._triggerElement = null;
      this.setAttribute('aria-hidden', 'true');
      if (element != null) {
        if (element.dataset.close != null) {
          return;
        }
      }
      if (this.isTouchScreen() == true) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    });
  }
});